export default __webpack_public_path__ + "static/logo-1d7a0c88355a5f86bf8b8e07c4aa6e5e.png";